import React from 'react';
import classnames from 'classnames';

import style from './index.scss';

const Footbar = (props) => {
  return (
    <div className={classnames(style.wrapper)}>
      <footer>Reserved by Tookitaki Holding Pte Ltd.</footer>
    </div>
  );
};

Footbar.propTypes = {};

export default Footbar;
